import { MediaType } from './enums';
import { SliderParams } from '@/modules/lobby/components/LobbyGamesSlider';

export const getSliderParams = (
  sliderParams: SliderParams,
  mediaType?: MediaType
) => {
  const paramsMap = {
    [MediaType.DESKTOP_L]: sliderParams.desktopL,
    [MediaType.DESKTOP]: sliderParams.desktop,
    [MediaType.TABLET]: sliderParams.tablet,
    [MediaType.MOBILE]: sliderParams.mobile,
    [MediaType.MOBILE_S]: sliderParams.mobileS,
  };

  return paramsMap[mediaType ?? MediaType.MOBILE_S];
};
